import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { NorthernColors } from './models';

@Component({
    selector: '[northern-lights]',
    templateUrl: './northern-lights.component.html',
    styleUrls: ['./northern-lights.component.css'],
    host: { class: 'transition-all duration-1000 ease-in-out w-full', style: 'overflow: hidden;' },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NorthernLightsComponent implements OnInit, OnDestroy {
  NorthernColors = NorthernColors;
  @Input() externalClass: string;
  @Input() color: NorthernColors;
  @Input() flashColor: NorthernColors;
  @Input() flash: boolean = false;

  private rotationInterval: any;
  private isColorRotate = false;
  private isFlashColorRotate = false;

  // NorthernColors enum'undan `Rotate` ve `None` değerlerini filtreleyerek bir renk dizisi oluşturuyoruz
  private colorSequence = Object.values(NorthernColors).filter(
    (color) => typeof color === 'number' && color !== NorthernColors.Rotate && color !== NorthernColors.None
  ) as NorthernColors[];

  constructor() { }

  ngOnInit() {
    // Rotate modunda olup olmadığını kontrol et
    this.isColorRotate = this.color === NorthernColors.Rotate;
    this.isFlashColorRotate = this.flashColor === NorthernColors.Rotate;

    if (this.isColorRotate || this.isFlashColorRotate) {
      this.startRotation();
    }
  }

  ngOnDestroy() {
    // Bileşen yok edilirken döngüyü durdur
    this.stopRotation();
  }

  private startRotation() {
    // color ve flashColor için başlangıç renklerini belirle
    const colorStartIndex = this.isColorRotate ? 0 : this.colorSequence.indexOf(this.color);
    const flashColorStartIndex = this.isFlashColorRotate ? 0 : this.colorSequence.indexOf(this.flashColor);

    let colorIndex = colorStartIndex;
    let flashColorIndex = flashColorStartIndex;

    this.rotationInterval = setInterval(() => {
      // Renk dizisinin sonuna ulaşıldığında tekrar başa dön
      if (this.isColorRotate) {
        colorIndex = (colorIndex + 1) % this.colorSequence.length;
        this.color = this.colorSequence[colorIndex];
      }
      if (this.isFlashColorRotate) {
        flashColorIndex = (flashColorIndex + 1) % this.colorSequence.length;
        this.flashColor = this.colorSequence[flashColorIndex];
      }
    }, 5000); // Her 5 saniyede bir geçiş yap
  }

  private stopRotation() {
    if (this.rotationInterval) {
      clearInterval(this.rotationInterval);
    }
  }
}